import * as Lambda from '../services/LambdaApi';

const fetchSignedUrl = async (facilityId: string, folder: string, fileName: string) => {
    try {
        const apiPath = `/s2l/${facilityId}/fetchS2LSignedURL`;
        const response = await Lambda.Post(apiPath, { Folder: folder, FileName: fileName }, 'lambda');
        if (!response || !response.Result || !response.Result.Content || !response.Result.Success) {
            throw new Error('Error while fetching signed URL.');
        }
        return response.Result.Content;
    } catch (error) {
        throw new Error('Error while fetching signed URL.');
    }
};

const formatFileNameWithTimestamp = (fileName: string): string => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const nameWithoutExtension = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
    const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex + 1) : '';
    return extension ? `${nameWithoutExtension}_${Date.now()}.${extension}` : `${nameWithoutExtension}_${Date.now()}`;
};

export { fetchSignedUrl, formatFileNameWithTimestamp };